@if (!edit && !image && !isChangingPassword) {
  <div class="profile-container">
    @if (profile) {
      <div class="flex space-between">
        <div class="details">
          <div class="account-info">
            <h4>
              {{ 'PROFILE.MY_INFORMATION' | translate }}
              <i
                (click)="edit = !edit"
                class="link edit"
                appBrandingColor
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                styleType="color"
                >{{ 'PROFILE.EDIT' | translate }}</i
              >
            </h4>
            <div class="info">
              <span class="label">{{ 'PROFILE.NAME' | translate }}</span>
              <p class="profile-name">{{ profile.fullName }}</p>
            </div>
            @if (profile.company) {
              <div class="info">
                <span class="label">{{ 'PROFILE.COMPANY' | translate }}</span>
                <p class="company-name">{{ profile.company }}</p>
              </div>
            }
            @if (profile.title) {
              <div class="info">
                <span class="label">{{ 'PROFILE.TITLE' | translate }}</span>
                <p class="title-name">{{ profile.title }}</p>
              </div>
            }
            <div class="info">
              <span class="label">{{ 'PROFILE.EMAIL' | translate }}</span>
              @for (email of profile.emails; track $index) {
                <div class="info-grid">
                  <span>
                    {{ email.value }}
                  </span>
                  <span>{{ email.type | titlecase }}</span>
                </div>
              }
            </div>
            <div class="info">
              <span class="label">{{ 'PROFILE.EXTENSION' | translate }}</span>
              <div class="info-grid">
                <span>
                  {{ profile.ext }}
                </span>
              </div>
            </div>
            <div class="info">
              <span class="label">{{ 'PROFILE.PHONE_NUMBERS' | translate }}</span>
              @for (DID of DIDNumbers; track $index) {
                <div class="info-grid">
                  <span>
                    {{ DID | phoneNumber }}
                  </span>
                  <span>{{ 'PROFILE.DID' | translate }}</span>
                </div>
              }
              @for (phone of profile.tels; track $index) {
                <div class="info-grid">
                  <span>
                    {{ phone.number | phoneNumber }}
                  </span>
                  @if (phone.type === ExtensionTypes.SMS || phone.type === ExtensionTypes.PbxSms) {
                    <span>{{ phone.type | uppercase }}</span>
                  } @else {
                    <span>{{ phone.type | titlecase }}</span>
                  }
                </div>
              }
            </div>
            <div class="info">
              <span class="label">{{ 'PROFILE.ADDRESS' | translate }}</span>
              @for (address of profile.addresses; track $index) {
                <div class="info-grid">
                  <span>
                    {{ address.addressLine1 }} {{ address.city }} {{ address.state }} {{ address.postalCode }}
                  </span>
                  <span>{{ address.type | titlecase }}</span>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="avatar">
          @if (!profile.avatar) {
            <div class="bigCoin">
              <span>{{ getCoin() }}</span>
            </div>
            <h2 class="full-name">{{ profile.fullName }}</h2>
            <span
              class="link"
              (click)="file.click()"
              >{{ 'PROFILE.CHOOSE_PROFILE_PHOTO' | translate }}</span
            >
          } @else {
            @if (avatarLoading) {
              <mat-spinner class="avatar-spinner" />
            } @else {
              <div class="bigCoin">
                <img
                  alt="avatar"
                  [src]="profile.avatar" />
                <div
                  (click)="file.click()"
                  class="overlay">
                  <mat-icon>add_a_photo</mat-icon>
                </div>
              </div>
            }
            <button
              style="height: auto; min-height: 36px"
              (click)="file.click()"
              color="primary"
              mat-raised-button
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
              {{ 'PROFILE.CHOOSE_PHOTO' | translate }}
            </button>
            @if (!profile.avatar.startsWith(defaultAvatarsBaseUrl)) {
              <button
                (click)="removeAvatar()"
                mat-button>
                {{ 'PROFILE.REMOVE_PHOTO' | translate }}
              </button>
            }
          }
          <div class="img-format">
            <div class="file-types">{{ 'PROFILE.FILE_TYPES' | translate }}: jpg,png,jpeg,gif,svg</div>
            <div class="file-types">
              {{ 'PROFILE.SIZE_UP_TO' | translate }}
              <!-- Size: up to 1024 KB -->
            </div>
          </div>
        </div>
        <input
          #file
          appAvatar
          (changeEvent)="fileChangeEvent($event)" />
      </div>
    }

    @let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
    @if (configService.features[AppFeature.EnableDarkMode]) {
      <div class="account-info">
        <h4>{{ 'PROFILE.APPEARENCE' | translate }}</h4>
        <mat-radio-group
          color="primary"
          [(ngModel)]="darkMode"
          (change)="onAppearenceChange()">
          <mat-radio-button
            value="light"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
            >{{ 'PROFILE.LIGHT' | translate }}
          </mat-radio-button>
          <mat-radio-button
            value="dark"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
            >{{ 'PROFILE.DARK' | translate }}
          </mat-radio-button>
          <mat-radio-button
            value="system"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
            >{{ 'PROFILE.SYSTEM' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    }
    <div class="account-info">
      <h4>{{ 'PROFILE.TIME_FORMAT' | translate }}</h4>
      <div class="info">
        <div class="flex align-items-center space-between m-b-8">
          <div class="label">{{ 'PROFILE.HOUR_FORMAT' | translate }}</div>
          <div class="label timezone">
            {{ 'PROFILE.TIMEZONE_COMPUTER_DEFAULT' | translate }}
            <!-- Timezone (Computer Default) -->
          </div>
        </div>
        <div class="flex space-between hour-format">
          <mat-radio-group
            color="primary"
            [(ngModel)]="selectedHourFormat"
            (change)="onHourFormatChange()">
            <mat-radio-button
              value="12"
              [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
              >{{ 'PROFILE.12_HOUR' | translate }}</mat-radio-button
            >
            <mat-radio-button
              value="24"
              [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
              >{{ 'PROFILE.24_HOUR' | translate }}</mat-radio-button
            >
          </mat-radio-group>
          <div class="fs-12 timezone m-t-8">{{ localTimezone }}</div>
        </div>
      </div>
    </div>
    <div class="account-info">
      <h4>{{ 'PROFILE.LANGUAGE' | translate }}</h4>
      <div class="info">
        <div class="flex space-between">
          <mat-select
            (selectionChange)="onUILanguageChanged($event.value)"
            value="{{ appTranslateService.selectedLanguage }}">
            @for (lang of availableLanguages; track lang.key) {
              <mat-option value="{{ lang.key }}">{{ lang.name }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
    </div>

    <div class="account-settings account-info">
      <h4>{{ 'PROFILE.ACCOUNT_SETTINGS' | translate }}</h4>
      <span class="label"
        >{{ 'PROFILE.SIGN_IN_PASSWORD' | translate }}
        <i
          (click)="isChangingPassword = true"
          class="edit"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
          styleType="color"
          >{{ 'PROFILE.CHANGE' | translate }}</i
        ></span
      >
    </div>
  </div>
}

@if (edit) {
  <app-contact
    (cancelAction)="onEditCanceled()"
    (saveAction)="onDataSubmitted($event)"
    [loading]="editProfileLoading"
    [contact]="profile"
    [showSharedContact]="false"
    [title]="'PROFILE.EDIT_PROFILE' | translate"
    style="height: 100%"></app-contact>
}

@if (image) {
  <app-transform-image
    [title]="'Set Profile Photo'"
    [imageChangedEvent]="imageChangedEvent"
    (cancelEvent)="image = false"
    (saveEvent)="save($event)"
    style="height: 100%" />
}
@if (isChangingPassword) {
  <app-change-password
    (passwordChange)="onPasswordChange($event)"
    (cancelChanges)="onPasswordChangeCanceled()"></app-change-password>
}
